import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkMode = new BehaviorSubject<boolean>(false);
  public isDarkMode$ = this.darkMode.asObservable();

  constructor() {
    // Check if user has a saved preference
    const savedTheme = localStorage.getItem('darkMode-converge');
    if (savedTheme) {
      this.darkMode.next(savedTheme === 'true');
    } else {
      // Check system preference
      // disabling for now as to not surprise users
      // this.darkMode.next(window.matchMedia('(prefers-color-scheme: dark)').matches);
    }
  }

  toggleTheme(): void {
    const newValue = !this.darkMode.value;
    localStorage.setItem('darkMode-converge', newValue.toString());
    this.darkMode.next(newValue);
  }
}
